import React from "react"
import clsx from "clsx"
import Switch from "../../Switch/Switch"

export default class CustomerPortalSettingsBuilderGeneral extends React.Component {
  constructor(props) {
      super(props)
  }

  render() {
    var tabClasses = clsx({
        'active': this.props.active_tab == 'general',
        'tab-pane': true,
    })

    return (
      <div className={tabClasses} id="general">
        <div className="row active tab-pane">
          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('check_in')} <span className="ss-help help" title={I18n.t('customer_portal_settings_check_in_helper_text')}></span></label>
              <Switch onText="enabled" switchId="check-in" offText="disabled" onChange={this.props.onChangeCheckIn} value={this.props.customer_portal_setting.check_in} />
            </div>
          </div>

          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('check_out')} <span className="ss-help help" title={I18n.t('customer_portal_settings_check_out_helper_text')}></span></label>
              <Switch onText="enabled" switchId="check-out" offText="disabled" onChange={this.props.onChangeCheckOut} value={this.props.customer_portal_setting.check_out} />
            </div>
          </div>

          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('cancel_reservation')} <span className="ss-help help" title={I18n.t('customer_portal_settings_cancel_reservation_helper_text')}></span></label>
              <Switch onText="enabled" switchId="cancel-res" offText="disabled" onChange={this.props.onChangeCancelReservation} value={this.props.customer_portal_setting.cancel_reservation} />
            </div>
          </div>
        </div>
        <div className="row active tab-pane">
          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('send_invitation')} <span className="ss-help help" title={I18n.t('customer_portal_settings_send_invitation_helper_text')}></span></label>
              <Switch onText="enabled" switchId="send_invitation" offText="disabled" onChange={this.props.onChangeSendInvitation} value={this.props.customer_portal_setting.send_invitation} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
